import { useEffect } from "react";

function useBlur(selector) {
    useEffect(() => {
        const handleMouseClick = (event) => {
            document.activeElement.blur();
        }

        document.querySelector(selector).addEventListener('click', handleMouseClick);

        return () => {
            document.querySelector(selector).removeEventListener('click', handleMouseClick);
        }
    }, []);
}

export default useBlur;